import React from "react";
import Icons from "../../../../config/images";
import "./aboutImage.css";

const AboutImage = () => {
  return (
    <>
      <div className="about-us-image">
        <h1 className="seo-hidden">
          About BA Code Solutions – Web Development Company in Ahmedabad
        </h1>

        <img src={Icons.aboutus_banner_img} alt="about-us-image" />
      </div>
    </>
  );
};

export default AboutImage;
